import {useEffect, useState} from "react";
import axios from "axios";
import {DataTable} from "./components/DataTable";
import {FilterSection} from "./components/FilterSection";
import {useLocation, useParams} from "react-router-dom";
import {REST_URL} from "../../component/const/Const";

export const User2 = () => {
    const {site} = useParams();  // URL에서 :site 값을 가져옴
    const [tableData, setTableData] = useState([])
    const [checkBoxData, setCheckBoxData] = useState(null)
    const [searchQuery, setSearchQuery] = useState("")
    const [maxCnt, setMaxCnt] = useState(null);
    const [page, setPage] = useState(1); // 현재 페이지
    const limit = 10
    const [tabArray, setTabArray] = useState([])
    const [selectedTab, setSelectedTab] = useState('')
    const admin = "admin_"
    const baseUrl = REST_URL + admin
    const rpcUrl = REST_URL + "rpc/";
    const topBarUrl = rpcUrl + "get_top_bar";
    const filterUrl = rpcUrl + "get_with_type_limit_1";
    const enumUrl = rpcUrl + "get_enum_values";

    const {pathname} = useLocation()

    const search = () => {
        const from = (page - 1) * limit;
        const to = from + limit - 1;
        axios.get(`${baseUrl}${site}${selectedTab}_with_udt_text${searchQuery}`, {
            headers: {
                Range: `${from}-${to}`
            }
        }).then(data => {
            setTableData(data.data)
        }).catch(e => {

            console.error("Error", e)
        });
    };

    const loadTabArray = async () => {
        try {
            const {data} = await axios.get(`${topBarUrl}?v_name=${admin}${pathname.split('/')[1]}`)
            setTabArray(data)
        } catch (e) {
            setTabArray(["", "_회원관리", "_활동관리", "_결제관리", "_1:1 문의 관리"])
        }
    }

    const callCheckBoxData = async () => {
        console.log(site, selectedTab)
        const res = await axios.get(`${filterUrl}?t_name=admin_${site}${selectedTab}`);
        const withType = res.data[0][0];
        console.log(withType);
        const userDefined = Object.keys(withType).reduce((acc, key) => {
            acc[key] = withType[key].type;
            return acc;
        }, {})
        console.log(userDefined)
        const keys = Object.keys(userDefined).filter(key => userDefined[key] === 'USER-DEFINED');
        console.log(keys);
        const listEnum = keys.map(async key => {
            const {data} = await axios.get(`${enumUrl}?p_enum_name=${key}`)
            return {key, data}
        })
        const result = await Promise.all(listEnum)
        console.log(result)
        const checkBox = {}
        result.forEach(it => {
            if (it.key) checkBox[it.key] = it.data
        })
        console.log(checkBox)
        setCheckBoxData(checkBox)
    }

    useEffect(() => {
        loadTabArray()
    }, []);


    useEffect(() => {
        setTableData([])
        setCheckBoxData(null)
        setSearchQuery("")
        axios.get(`${baseUrl}${site}${selectedTab}_with_udt_text`, {
            headers: {
                Prefer: "count=exact",
                Range: `${0}-${9}`
            },
        }).then(data => {
            setTableData(data.data)
            setMaxCnt(Number(data.headers["content-range"].split("/")[1]))
            callCheckBoxData()
        }).catch(e => {
            console.error("err", e)
        })
    }, [site, selectedTab]);

    useEffect(() => {
        if (checkBoxData) {
            search();
        }
    }, [page]);

    useEffect(() => {
        setPage(1);
    }, [searchQuery]);

    return (
        <main className={`w-full  h-screen overflow-x-scroll`}>
            <div className='p-6'>
                <ul className={`flex gap-2 text-2xl `}>
                    {
                        tabArray.map((item, index) => {
                            return <li
                                onClick={() => {
                                    setSelectedTab(item)
                                }}
                                className={`text-center px-12 py-2 rounded-2xl border-2 text-xl rounded-b-none border-b-0 ${selectedTab === item ? "bg-slate-800 text-white" : ""}`}
                                key={index}>{item === "" ? "전체" : item.replace("_", "")}</li>
                        })
                    }
                </ul>
                {checkBoxData &&
                    <FilterSection
                        data={tableData}
                        checkboxData={checkBoxData}
                        setSearchQuery={setSearchQuery}
                        search={search}/>}
            </div>
            <DataTable data={tableData}/>
            <div className="flex gap-2 justify-center mt-4">
                <button
                    onClick={() => setPage((prev) => Math.max(prev - 1, 1))}
                    disabled={page === 1}
                    className="px-4 py-2 bg-gray-300 rounded"
                >
                    이전
                </button>
                <span className="px-4 py-2">페이지 {page}/{Math.ceil(maxCnt / 10)}</span>
                <button
                    onClick={() => {
                        const maxPage = Math.ceil(maxCnt / limit);
                        setPage((prev) => Math.min(prev + 1, maxPage));
                    }}
                    disabled={page >= Math.ceil(maxCnt / limit)}
                    className="px-4 py-2 bg-gray-300 rounded"
                >
                    다음
                </button>
            </div>

        </main>
    )
}